<template>
  <el-dialog title="选择学校" :visible.sync="visible" @close="close" style="width: 60%;margin-left: 24%">
    <el-row class="bind-box">
      <div v-if="show_type > 0" id="kr1" style="margin-left: 80px">
        <span v-if="showData.school_type !== '6' && showData.school_type !== '7' && showData.school_type !== '8'">大学</span>
        <span v-if="showData.school_type !== '6' && showData.school_type !== '7' && showData.school_type !== '8'">
          <jm-school-search
            style="margin-left: 50px"
            :country-id="672"
            ref="korea_school_search"
            :value="editData.kr_fir_id"
            @change="selectKoreaSchool1"
          />
        </span>
        <span v-if="showData.school_type === '6' || showData.school_type === '7' || showData.school_type === '8'">语学院</span>
        <span v-if="showData.school_type === '6' || showData.school_type === '7' || showData.school_type === '8'">
          <jm-school-search
            style="margin-left: 36px"
            :country-id="672"
            ref="korea_school_search"
            :value="editData.kr_fir_id"
            @change="selectKoreaSchool1"
          />
        </span>
        <br>
      </div>
      <div v-if="show_type > 1" id="kr2" style="margin-left: 80px">
        <span>大学</span>
        <jm-school-search
          style="margin-left: 50px"
          :country-id="672"
          ref="korea_school_search"
          :value="editData.kr_sec_id"
          @change="selectKoreaSchool2"
        />
        <br>
      </div>
      <div v-if="show_type > 2" id="kr3" style="margin-left: 80px">
        <span>大学</span>
        <jm-school-search
          style="margin-left: 50px"
          :country-id="672"
          ref="korea_school_search"
          :value="editData.kr_thr_id"
          @change="selectKoreaSchool3"
        />
        <br>
      </div>
      <div v-if="show_type > 3" id="kr4" style="margin-left: 80px">
        <span>大学</span>
        <jm-school-search
          style="margin-left: 50px"
          :country-id="672"
          ref="korea_school_search"
          :value="editData.kr_fou_id"
          @change="selectKoreaSchool4"
        />
      </div>
    </el-row>
    <el-row class="bind-box jm-primary">
      <el-button type="primary" @click="saveKrSchool()">确定</el-button>
    </el-row>
  </el-dialog>
</template>
<script>
import { jmSchoolSearch } from '@/components/tool';

export default {
  name: 'KrSchoolForm',
  components: {
    jmSchoolSearch
  },
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    showData: {
      type: Object,
      default() {
        return {
          crm_id: 0,
          school_type: ''
        };
      }
    },
  },
  data() {
    return {
      editData: {
        kr_fir_id: null,
        kr_sec_id: null,
        kr_thr_id: null,
        kr_fou_id: null
      },
      show_type: 0
    };
  },
  methods: {
    async saveKrSchool() {
      await this.$http._post({
        url: '/index/student/saveKrSchool',
        data: { crmId: this.showData.crm_id, type: this.showData.school_type, school: this.editData }
      }).then((res) => {
        if (res.data.result === 1) {
          this.$message.success('选择学校成功');
        } else {
          this.$message.error('选择学校失败');
        }
      });
      await this.close();
      // 刷新
      this.currentKoreaSchools();
    },
    close() {
      this.$emit('update:visible', false);
      if (this.editData.kr_fir_id == null && this.editData.kr_sec_id == null && this.editData.kr_thr_id == null && this.editData.kr_fou_id == null) {
        this.$parent.resetType();
      }
    },
    resetSchool() {
      this.editData.kr_fir_id = '';
      this.editData.kr_sec_id = '';
      this.editData.kr_thr_id = '';
      this.editData.kr_fou_id = '';
    },
    selectKoreaSchool1(v) {
      if (!v) {
        return false;
      }
      this.editData.kr_fir_id = v;
    },
    selectKoreaSchool2(v) {
      if (!v) {
        return false;
      }
      this.editData.kr_sec_id = v;
    },
    selectKoreaSchool3(v) {
      if (!v) {
        return false;
      }
      this.editData.kr_thr_id = v;
    },
    selectKoreaSchool4(v) {
      if (!v) {
        return false;
      }
      this.editData.kr_fou_id = v;
    },
    showType() {
      if (this.showData.school_type === '1') {
        this.show_type = 1;
      }
      if (this.showData.school_type > '1' && this.showData.school_type < '6') {
        this.show_type = 3;
      }
      if (this.showData.school_type >= '6' && this.showData.school_type < '9') {
        this.show_type = 4;
      }
      if (this.showData.school_type >= '9' && this.showData.school_type < '13') {
        this.show_type = 3;
      }
      if (this.showData.school_type === '9') {
        this.show_type = 3;
      }
    },
    async currentKoreaSchool() {
      const { data } = await this.$http._post({
        url: '/index/student/currentKoreaSchool',
        data: { id: this.showData.crm_id }
      });
      if (data) {
        if (data.kr_fir_id) {
          this.editData.kr_fir_id = data.kr_fir_id;
        }
        if (data.kr_sec_id) {
          this.editData.kr_sec_id = data.kr_sec_id;
        }
        if (data.kr_thr_id) {
          this.editData.kr_thr_id = data.kr_thr_id;
        }
        if (data.kr_fou_id) {
          this.editData.kr_fou_id = data.kr_fou_id;
        }
      }
    },
    async currentKoreaSchools() {
      this.editData.save_school_type = this.showData.school_type;
      this.$parent.currentKoreaSchool(this.editData);
    },
  },
  mounted() {
    this.$nextTick(() => {
    });
  },
  watch: {
    visible(v) {
      if (v) {
        this.showType();
        this.currentKoreaSchool();
      }
    }
  }
};
</script>
<style scoped>
  .bind-box {
    line-height: 50px;
  }

  .input {
    width: 50%;
  }
</style>
